/**
 * R15-04 — textos do que esta travado para o aluno: aba com cadeado e aviso da rota.
 * Neutros de proposito: nao citam o plano nem mandam escolher outro.
 */
export const LOCKED_FEATURE_COPY = {
  tabTitle: (label: string): string => `${label} — bloqueado no momento`,
  tabAriaLabel: (label: string): string => `${label} (bloqueado no momento)`,
  noticeTitle: (label?: string): string =>
    label ? `${label}: bloqueado no momento` : 'Este recurso está bloqueado no momento',
  noticeBody:
    'Esta parte da plataforma não está disponível para você no momento. Se tiver dúvidas, fale com o suporte.',
} as const
